module.exports = __webpack_public_path__ + "static/capita-080b173274295ae45105450f8be0cffe.png";